<template>
  <Vat v-if="vatIncluded" />
</template>

<script setup lang="ts">
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import Vat from '~/scopes/product-core/components/presentationals/Vat/Vat.vue'

const {
  features: { vatIncluded },
} = useMarketplace()
</script>
